/* Malali — fiche produit (section malali-product).
   Variantes, galerie, quantité et ajout au panier branché sur le tiroir panier du thème
   (événement « cart:updated », comme le formulaire produit d'origine). */
(() => {
  const formatMoney = (cents, format) => {
    const value = (cents / 100);
    const fmt = (n, dec, thousands, decimal) => {
      const [int, frac] = n.toFixed(dec).split('.');
      return int.replace(/\B(?=(\d{3})+(?!\d))/g, thousands) + (frac ? decimal + frac : '');
    };
    return (format || '{{amount}} €').replace(/\{\{\s*(\w+)\s*\}\}/, (_, key) => ({
      amount: fmt(value, 2, ',', '.'),
      amount_no_decimals: fmt(value, 0, ',', '.'),
      amount_with_comma_separator: fmt(value, 2, '.', ','),
      amount_no_decimals_with_comma_separator: fmt(value, 0, '.', ','),
      amount_with_space_separator: fmt(value, 2, ' ', ','),
      amount_with_apostrophe_separator: fmt(value, 2, "'", '.'),
    }[key] ?? fmt(value, 2, ',', '.')));
  };

  const init = (root) => {
    if (root.dataset.mllPdpReady) return;
    root.dataset.mllPdpReady = '1';
    const data = JSON.parse(root.querySelector('[data-mll-product]')?.textContent || '{}');
    const variants = data.variants || [];
    const form = root.querySelector('form[action$="/cart/add"]');
    const idInput = root.querySelector('[data-mll-variant-id]');
    const addBtns = [...root.querySelectorAll('[data-mll-add]')];
    const addBtn = addBtns[0];
    const errorBox = root.querySelector('[data-mll-error]');
    const rail = root.querySelector('[data-mll-gallery]');
    const thumbs = [...root.querySelectorAll('[data-mll-thumb]')];

    /* Galerie : vignettes <-> piste */
    const goTo = (i) => rail && rail.scrollTo({ left: rail.clientWidth * i, behavior: 'smooth' });
    thumbs.forEach((t) => t.addEventListener('click', () => goTo(+t.dataset.mllThumb)));
    rail?.addEventListener('scroll', () => {
      const i = Math.round(rail.scrollLeft / Math.max(1, rail.clientWidth));
      thumbs.forEach((t, n) => t.classList.toggle('is-active', n === i));
    }, { passive: true });

    /* Quantité */
    root.querySelectorAll('[data-mll-qty]').forEach((b) => b.addEventListener('click', () => {
      const input = root.querySelector('input[name="quantity"]');
      input.value = Math.max(1, (parseInt(input.value, 10) || 1) + +b.dataset.mllQty);
    }));

    /* Variantes */
    const optionInputs = [...root.querySelectorAll('[data-mll-opt]')];
    const selected = () => {
      const values = [];
      optionInputs.forEach((i) => { if (i.checked) values[+i.dataset.mllOpt] = i.value; });
      return values;
    };
    const setButton = (variant) => {
      const ok = variant && variant.available;
      addBtns.forEach((btn) => {
        btn.disabled = !ok;
        const text = btn.querySelector('[data-mll-add-text]');
        if (text) text.textContent = ok ? btn.dataset.label : btn.dataset.soldout;
      });
    };
    const markUnavailable = (values) => {
      optionInputs.forEach((input) => {
        const pos = +input.dataset.mllOpt;
        const probe = values.slice(); probe[pos] = input.value;
        const exists = variants.some((v) => v.available && v.options.every((o, k) => probe[k] === undefined || o === probe[k]));
        input.closest('.mll-pdp__value')?.classList.toggle('is-unavailable', !exists);
      });
    };
    const onChange = () => {
      const values = selected();
      values.forEach((v, k) => { const l = root.querySelector(`[data-mll-legend="${k}"]`); if (l) l.textContent = v; });
      const variant = variants.find((v) => v.options.every((o, k) => o === values[k]));
      markUnavailable(values);
      setButton(variant);
      if (!variant) return;
      if (idInput) idInput.value = variant.id;
      const nows = root.querySelectorAll('[data-mll-now]');
      const was = root.querySelector('[data-mll-was]');
      const save = root.querySelector('[data-mll-save]');
      nows.forEach((n) => (n.textContent = formatMoney(variant.price, data.moneyFormat)));
      const promo = variant.compare_at_price && variant.compare_at_price > variant.price;
      if (was) { was.hidden = !promo; if (promo) was.textContent = formatMoney(variant.compare_at_price, data.moneyFormat); }
      if (save) { save.hidden = !promo; if (promo) save.textContent = `-${Math.round((1 - variant.price / variant.compare_at_price) * 100)} %`; }
      const mediaId = variant.featured_media?.id;
      if (mediaId && rail) {
        const slides = [...rail.children];
        const i = slides.findIndex((s) => s.dataset.mediaId == mediaId);
        if (i >= 0) goTo(i);
      }
      const url = new URL(location.href);
      url.searchParams.set('variant', variant.id);
      history.replaceState(null, '', url);
    };
    optionInputs.forEach((i) => i.addEventListener('change', onChange));
    if (optionInputs.length) markUnavailable(selected());

    /* Barre collante : visible quand le bouton principal a quitté l'écran (vers le haut) */
    const sticky = root.querySelector('[data-mll-sticky]');
    if (sticky && addBtn && 'IntersectionObserver' in window) {
      new IntersectionObserver(([entry]) => {
        const show = !entry.isIntersecting && entry.boundingClientRect.top < 0;
        sticky.classList.toggle('is-visible', show);
        sticky.setAttribute('aria-hidden', String(!show));
        sticky.querySelector('button')?.setAttribute('tabindex', show ? '0' : '-1');
      }).observe(addBtn);
    }

    /* Vus récemment : on retient ce produit dans le navigateur du visiteur */
    if (data.handle) {
      try {
        const list = JSON.parse(localStorage.getItem('mll-recent') || '[]').filter((h) => h !== data.handle);
        localStorage.setItem('mll-recent', JSON.stringify([data.handle, ...list].slice(0, 12)));
      } catch (e) {}
    }

    /* Ajout au panier */
    const showError = (msg) => { if (errorBox) { errorBox.textContent = msg; errorBox.hidden = !msg; } };
    form?.addEventListener('submit', async (e) => {
      const cartIcon = document.querySelector('cart-icon');
      const drawer = document.querySelector('cart-drawer');
      if (!cartIcon && !drawer) return; // pas de tiroir panier : envoi classique vers /cart
      e.preventDefault();
      showError('');
      addBtns.forEach((b) => { b.classList.add('is-loading'); b.disabled = true; });
      const quantity = parseInt(form.querySelector('input[name="quantity"]')?.value, 10) || 1;
      try {
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: +idInput.value, quantity }], sections: drawer?.dataset.sectionId || '' }),
        });
        const json = await res.json();
        if (!res.ok) throw new Error(json.description || json.message || "Impossible d'ajouter ce produit.");
        const count = cartIcon?.getCurrentItemCount?.();
        const event = new Event('cart:updated', { bubbles: true });
        event.detail = { resource: {}, data: { itemCount: count != null && !isNaN(count) ? count + quantity : undefined, source: 'malali-product', sections: json.sections } };
        document.dispatchEvent(event);
        if (cartIcon?.addToCartBehavior === 'notification') {
          document.dispatchEvent(new CustomEvent('toast:open', { detail: { type: 'success', message: window.Theme?.translations?.addToCartNotificationMessage || 'Ajouté au panier' } }));
        }
      } catch (err) {
        showError(err.message || "Une erreur est survenue. Réessaie dans un instant.");
      } finally {
        addBtns.forEach((b) => b.classList.remove('is-loading'));
        setButton(variants.find((v) => String(v.id) === String(idInput.value)));
      }
    });
  };

  const scan = () => document.querySelectorAll('[data-mll-pdp]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan); else scan();
  document.addEventListener('shopify:section:load', scan);
})();
